var map = {
	"./1.png": 809,
	"./2.png": 241,
	"./3.png": 237,
	"./4.png": 716,
	"./5.png": 47,
	"./6.png": 680,
	"./7.png": 24,
	"./8.png": 362,
	"./9.png": 437,
	"./character.png": 321,
	"./logo.png": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;